import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfCustomerImport(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "DATE", key: "date", width: 10 },
    { header: "FILE NAME", key: "file_name", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 10 },
    { header: "STATUS", key: "status", width: 10 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    date: item?.transaction_date ?? "-",
    file_name: item?.file_name ?? "-",
    description: item?.file_description ?? "-",
    status: item?.status ?? "-",
  }));

  return (
    <PdfTemplate data={dataMap} column={columns} title="CUSTOMER IMPORT" />
  );
}
